/* tslint:disable */
/* eslint-disable */
/**
 * Illio Wealth API
 * [Environment: dev], Manage your account, add trades, view portfolio performance and pnl
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@illio.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../../base';
// @ts-ignore
import { ErrorResponseBody } from '../../aggregator';
// @ts-ignore
import { PortfolioPnlPerCustodianRequest } from '../../aggregator';
// @ts-ignore
import { PortfolioPnlPerCustodianResponse } from '../../aggregator';
// @ts-ignore
import { ReportingReturnContributionRequest } from '../../aggregator';
// @ts-ignore
import { ReportingReturnContributionResponse } from '../../aggregator';
/**
 * ReportingControllerApi - axios parameter creator
 * @export
 */
export const ReportingControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {PortfolioPnlPerCustodianRequest} portfolioPnlPerCustodianRequest 
         * @param {number} [illioSelectedAccount] 
         * @param {number} [illioSelectedWorkgroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioPnlPerCustodian1: async (portfolioPnlPerCustodianRequest: PortfolioPnlPerCustodianRequest, illioSelectedAccount?: number, illioSelectedWorkgroup?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'portfolioPnlPerCustodianRequest' is not null or undefined
            assertParamExists('getPortfolioPnlPerCustodian1', 'portfolioPnlPerCustodianRequest', portfolioPnlPerCustodianRequest)
            const localVarPath = `/v1/reporting/perCustodians`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (illioSelectedAccount !== undefined && illioSelectedAccount !== null) {
                localVarHeaderParameter['illio-selected-account'] = String(JSON.stringify(illioSelectedAccount));
            }

            if (illioSelectedWorkgroup !== undefined && illioSelectedWorkgroup !== null) {
                localVarHeaderParameter['illio-selected-workgroup'] = String(JSON.stringify(illioSelectedWorkgroup));
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(portfolioPnlPerCustodianRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ReportingReturnContributionRequest} reportingReturnContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnContribution: async (reportingReturnContributionRequest: ReportingReturnContributionRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportingReturnContributionRequest' is not null or undefined
            assertParamExists('returnContribution', 'reportingReturnContributionRequest', reportingReturnContributionRequest)
            const localVarPath = `/v1/reporting/return/contribution`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportingReturnContributionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportingControllerApi - functional programming interface
 * @export
 */
export const ReportingControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportingControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {PortfolioPnlPerCustodianRequest} portfolioPnlPerCustodianRequest 
         * @param {number} [illioSelectedAccount] 
         * @param {number} [illioSelectedWorkgroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPortfolioPnlPerCustodian1(portfolioPnlPerCustodianRequest: PortfolioPnlPerCustodianRequest, illioSelectedAccount?: number, illioSelectedWorkgroup?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PortfolioPnlPerCustodianResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPortfolioPnlPerCustodian1(portfolioPnlPerCustodianRequest, illioSelectedAccount, illioSelectedWorkgroup, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {ReportingReturnContributionRequest} reportingReturnContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async returnContribution(reportingReturnContributionRequest: ReportingReturnContributionRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportingReturnContributionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.returnContribution(reportingReturnContributionRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ReportingControllerApi - factory interface
 * @export
 */
export const ReportingControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportingControllerApiFp(configuration)
    return {
        /**
         * 
         * @param {PortfolioPnlPerCustodianRequest} portfolioPnlPerCustodianRequest 
         * @param {number} [illioSelectedAccount] 
         * @param {number} [illioSelectedWorkgroup] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPortfolioPnlPerCustodian1(portfolioPnlPerCustodianRequest: PortfolioPnlPerCustodianRequest, illioSelectedAccount?: number, illioSelectedWorkgroup?: number, options?: any): AxiosPromise<Array<PortfolioPnlPerCustodianResponse>> {
            return localVarFp.getPortfolioPnlPerCustodian1(portfolioPnlPerCustodianRequest, illioSelectedAccount, illioSelectedWorkgroup, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {ReportingReturnContributionRequest} reportingReturnContributionRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        returnContribution(reportingReturnContributionRequest: ReportingReturnContributionRequest, options?: any): AxiosPromise<ReportingReturnContributionResponse> {
            return localVarFp.returnContribution(reportingReturnContributionRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportingControllerApi - object-oriented interface
 * @export
 * @class ReportingControllerApi
 * @extends {BaseAPI}
 */
export class ReportingControllerApi extends BaseAPI {
    /**
     * 
     * @param {PortfolioPnlPerCustodianRequest} portfolioPnlPerCustodianRequest 
     * @param {number} [illioSelectedAccount] 
     * @param {number} [illioSelectedWorkgroup] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingControllerApi
     */
    public getPortfolioPnlPerCustodian1(portfolioPnlPerCustodianRequest: PortfolioPnlPerCustodianRequest, illioSelectedAccount?: number, illioSelectedWorkgroup?: number, options?: AxiosRequestConfig) {
        return ReportingControllerApiFp(this.configuration).getPortfolioPnlPerCustodian1(portfolioPnlPerCustodianRequest, illioSelectedAccount, illioSelectedWorkgroup, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {ReportingReturnContributionRequest} reportingReturnContributionRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportingControllerApi
     */
    public returnContribution(reportingReturnContributionRequest: ReportingReturnContributionRequest, options?: AxiosRequestConfig) {
        return ReportingControllerApiFp(this.configuration).returnContribution(reportingReturnContributionRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
